var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShipping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20,
    fill: "#EEFFFC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15V16.5H24.75V27.75H20.133C19.7985 26.4608 18.639 25.5 17.25 25.5C15.861 25.5 14.7015 26.4608 14.367 27.75H13.5V24H12V29.25H14.367C14.7015 30.5392 15.861 31.5 17.25 31.5C18.639 31.5 19.7985 30.5392 20.133 29.25H26.367C26.7015 30.5392 27.861 31.5 29.25 31.5C30.639 31.5 31.7985 30.5392 32.133 29.25H34.5V23.133L34.4528 23.0153L32.9528 18.5153L32.79 18H26.25V15H10.5ZM11.25 18V19.5H18V18H11.25ZM26.25 19.5H31.7108L33 23.3438V27.75H32.133C31.7985 26.4608 30.639 25.5 29.25 25.5C27.861 25.5 26.7015 26.4608 26.367 27.75H26.25V19.5ZM12 21V22.5H16.5V21H12ZM17.25 27C18.0877 27 18.75 27.6623 18.75 28.5C18.75 29.3377 18.0877 30 17.25 30C16.4123 30 15.75 29.3377 15.75 28.5C15.75 27.6623 16.4123 27 17.25 27ZM29.25 27C30.0877 27 30.75 27.6623 30.75 28.5C30.75 29.3377 30.0877 30 29.25 30C28.4123 30 27.75 29.3377 27.75 28.5C27.75 27.6623 28.4123 27 29.25 27Z",
    fill: "#0FAA8E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(10.5 10.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipping);
export default __webpack_public_path__ + "static/media/shipping.0be50becd08cf6b797a80196f62141f3.svg";
export { ForwardRef as ReactComponent };